import { Skeleton, VStack, HStack } from '@cdl/heartbeat-react';
import { PropsWithChildren } from 'react';

const BASE_CLUSTER_WIDTH = 364;
const BASE_CLUSTER_HEIGHT = 124;

export const LoadingBaseClusters: React.FC<PropsWithChildren> = ({
  children,
}) => {
  return (
    <VStack spacing='m' alignItems='inherit' pl='m'>
      <VStack
        alignItems='stretch'
        width='100vw'
        bgColor='neutral.0'
        p='m'
        ml='-m'
      >
        <HStack justifyContent='space-between'>
          <Skeleton width={200} height='1rem' variant='heartbeat' />
          <Skeleton width={170} height='2rem' variant='heartbeat' />
        </HStack>
        <HStack spacing='s'>
          {Array.from(Array(4), (x, i) => i).map((i) => (
            <Skeleton
              key={i}
              variant='heartbeat'
              width={BASE_CLUSTER_WIDTH}
              height={BASE_CLUSTER_HEIGHT}
            />
          ))}
        </HStack>
      </VStack>
      {children}
    </VStack>
  );
};
